import { useEffect } from "react";
import { logMetricEvent } from "../lib/delivery";
import { MetricEvents } from "@shared/integrations/delivery_keys";

/**
 * Fires `platform.page.viewed` once on mount with a stable `route` label.
 * Call this at the top of each page hook or component.
 */
export function usePageView(route: string): void {
  useEffect(() => {
    logMetricEvent(MetricEvents.platformPageViewed, { metadata: { route } });
  }, [route]);
}
